import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, emailAllowed, signOutUser } from './firebase';
import { DEV_MODE } from './lib/api';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

export default function App() {
  const [user, setUser] = useState(undefined); // undefined = still resolving

  useEffect(() => {
    if (DEV_MODE) return undefined;
    return onAuthStateChanged(auth, (firebaseUser) => {
      // A session persisted from before a denial never passes signInWithGoogle's check.
      if (firebaseUser && !emailAllowed(firebaseUser.email)) {
        signOutUser();
        setUser(null);
        return;
      }
      setUser(firebaseUser ?? null);
    });
  }, []);

  // `?dev` on the Vite dev server skips sign-in. It only works when the API server
  // also has ALLOW_DEV_AUTH set, so it can't unlock anything in production.
  if (DEV_MODE) return <Dashboard user={null} />;

  if (user === undefined) {
    return (
      <div style={splashStyle}>
        <svg
          style={{ animation: 'spin 0.8s linear infinite' }}
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#1c5cab"
          strokeWidth="2.5"
        >
          <circle cx="12" cy="12" r="10" strokeOpacity="0.2" />
          <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round" />
        </svg>
      </div>
    );
  }

  return user ? <Dashboard user={user} /> : <Login />;
}

const splashStyle = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f9f9f7',
};
